import errors from './errors/index.js';
import translation from './translation/index.js';
const ru = Object.freeze({
    translation,
    errors,
});
export default ru;
